import { type OnboardingStorageKey } from '../../../lib/storage';

export const ONBOARDING_HAS_CLICKED_ON_PUBLISH_STORAGE_KEY =
    'onboarding.hasClickedOnPublish' satisfies OnboardingStorageKey;
export const ONBOARDING_FINISHED_STORAGE_KEY = 'onboarding.finished' satisfies OnboardingStorageKey;

export const ONBOARDING_KIT_STEPS = {
    CHOOSE_DESIGN: 'choose-design',
    ADD_PRODUCTS: 'add-products',
    COMPANY_INFO: 'company-info',
    DELIVERY_PAYMENT: 'delivery-payment',
    DOMAIN_INTEGRATIONS: 'domain-integrations',
    PUBLISH: 'publish',
} as const;

export const ONBOARDING_KIT_SUBTASKS = {
    LEGAL_DOCS_FILLED: 'fill-legal-docs',
    SETUP_DOMAIN: 'setup-domain',
    AUTH_AS_ORG: 'auth-as-org',
    SETUP_DELIVERY: 'setup-delivery',
    SETUP_PAYMENT: 'setup-payment',
    SETUP_INTEGRATIONS: 'setup-integrations',
} as const;

export const ONBOARDING_EXTERNAL_CHECKOUT_STEPS = {
    INSTALL_KIT_MODULE: 'install-yandex-kit-module',
    SPECIFY_COMPANY_INFORMATION: 'specify-company-information',
    CONFIGURE_DELIVERY_AND_PAYMENT: 'configure-delivery-and-payment',
    ADD_PRODUCTS: 'external-add-products',
    CONNECT_YA_METRIC: 'external-connect-ya-metric',
    MAKE_TEST_ORDER: 'make-test-order',
    PUBLISH: 'publish-store',
} as const;

export const ONBOARDING_EXTERNAL_CHECKOUT_SUBTASKS = {
    IMPORT_WAREHOUSES: 'import-warehouses',
    CONFIGURE_PAYMENT: 'configure-payment',
    CONNECT_DELIVERY: 'connect-delivery',
} as const;

export const ONBOARDING_LITE_STEPS = {
    ADD_PRODUCTS: 'lite-add-products',
    SPECIFY_COMPANY_INFORMATION: 'lite-specify-company-information',
    CONNECT_DELIVERY_AND_PAYMENT: 'lite-setup-delivery-and-payment',
    CONNECT_METRIKA: 'lite-setup-ya-metric',
    MAKE_TEST_ORDER: 'lite-make-test-order',
    PUBLISH: 'lite-publish-store',
} as const;

export const ONBOARDING_LITE_SUBTASKS = {
    FILL_COMPANY_INFO: 'lite-fill-company-info',
    FILL_NECESSARY_PAGES: 'lite-fill-necessary-pages',
    CONNECT_DELIVERY: 'lite-setup-delivery',
    CONNECT_PAYMENT: 'lite-setup-payment',
} as const;
